<ion-list>
    <ion-item lines="full" button [detail]="false" (click)="onEdit()">
        <ion-icon name="create-outline" slot="end"></ion-icon>
        Edit
    </ion-item>
    <ion-item lines="full" button [detail]="false" (click)="onSave()">
        <ion-icon name="share-outline" slot="end"></ion-icon>
        Save
    </ion-item>
    <ion-item lines="full" button [detail]="false" (click)="onCopy()">
        <ion-icon name="copy-outline" slot="end"></ion-icon>
        Copy
    </ion-item>
    <ion-item lines="full" button [detail]="false" (click)="onCut()">
        <ion-icon name="cut-outline" slot="end"></ion-icon>
        Cut
    </ion-item>
    <ion-item lines="none" button [detail]="false" (click)="onDelete()">
        <ion-icon name="trash-outline" slot="end"></ion-icon>
        Delete
    </ion-item>
</ion-list>
